import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_messages = _resolveComponent("v-messages")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_v_btn_toggle, {
      "model-value": _ctx.answer,
      mandatory: _ctx.required,
      divided: "",
      density: "comfortable",
      variant: "outlined",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event === undefined ? null : $event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS, (option) => {
          return (_openBlock(), _createBlock(_component_v_btn, {
            key: String(option),
            value: option,
            readonly: _ctx.readonly,
            disabled: _ctx.loading,
            color: _ctx.faceOf(option).color
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.faceOf(option).icon), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(_toDisplayString(_ctx.faceOf(option).label), 1)
            ]),
            _: 2
          }, 1032, ["value", "readonly", "disabled", "color"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "mandatory"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          height: "2",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_v_messages, {
          key: 1,
          active: "",
          messages: _ctx.errorMessage,
          color: "error",
          class: "mt-1",
          role: "alert"
        }, null, 8, ["messages"]))
      : _createCommentVNode("", true)
  ]))
}